// const path = "./api/ajax/living_our_values.php";
// const mail = "./api/ajax/lovmailer.php";
// const report = "./api/ajax/Order_Report.php";
// const asmItemPath = "./api/ajax/asmPrizeCreate.php";

const path = "https://mykeysatgf.com/api/ajax/living_our_values.php";
const mail = "https://mykeysatgf.com/api/ajax/lovmailer.php";
const report = "https://mykeysatgf.com/api/ajax/Order_Report.php";
const asmItemPath = "https://mykeysatgf.com/api/ajax/asmPrizeCreate.php";
const loginPath = "https://mykeysatgf.com/api/ajax/handle_login.php";
const storeImagePath = "https://mykeysatgf.com";

// const path = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/living_our_values.php";
// const mail = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/lovmailer.php";
// const report = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/Order_Report.php";
// const asmItemPath = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/asmPrizeCreate.php";
// const loginPath = "http://localhost/gf_work/LOV-ASM-Tool/backend/api/ajax/handle_login.php";
// const storeImagePath = "https://mykeysatgf.com";

export {mail, path, report, asmItemPath, loginPath, storeImagePath};





// WEBPACK FOOTER //
// ./src/container/routes.js